import { render, staticRenderFns } from "./BankStatementFlowPage.vue?vue&type=template&id=2114fa4b&scoped=true&"
import script from "./BankStatementFlowPage.vue?vue&type=script&lang=ts&"
export * from "./BankStatementFlowPage.vue?vue&type=script&lang=ts&"
import style0 from "./BankStatementFlowPage.vue?vue&type=style&index=0&id=2114fa4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2114fa4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperHeader,VStepperStep})
